export default __webpack_public_path__ + "static/illu_student2-bfd7c32abd2db922af0e4e19263818ac.jpg";